import { styled } from '@mui/material';
export const PentairBulletList = styled('ul')(({ theme }) => ({
    padding: 0,
    listStyle: 'none',
    marginTop: 6,
    marginBottom: 0,
    '& li': {
        paddingLeft: '1.5em',
        marginBottom: '0.25em',
        position: 'relative',
        fontSize: '0.9rem',
    },
    '& li:after': {
        content: "''",
        height: '0.4em',
        width: '0.4em',
        background: theme.palette.brightBlue.main,
        display: 'block',
        position: 'absolute',
        transform: 'rotate(45deg)',
        top: '0.4em',
        left: '0.33em',
    },
}));
